import ErrorHandler from "./ErrorHandler"
import { api } from "services/api"

interface ApiMappingsPayload {
  productIds?: string
}

class ApiApiMappings extends ErrorHandler {
  async getAll(params?: ApiMappingsPayload) {
    const { data } = await api.get(`/api-mappings`, {
      params
    })

    return data
  }

  async getById(id?: string) {
    if (!id || id === "create") {
      // Fetch the form only
      const { data } = await api.get(`/api-mappings/form`)

      return data
    }

    const { data } = await api.get(`/api-mappings/edit/${id}`)

    return data
  }

  async create(apiMapping: App.ApiMapping) {
    return api.post("/api-mappings", apiMapping)
  }

  async update(apiMapping: App.ApiMapping, _id: string) {
    return api.patch(`/api-mappings/${_id}`, apiMapping)
  }

  async delete(_id: string | undefined) {
    return api.delete(`/api-mappings/${_id}`)
  }
}

export default ApiApiMappings
